import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	fetchTasks: ({ plantCd, urlSearchParams }) => {
		return client
			.get(`${BASE_URL}/task/v1/plants/${plantCd}/tasks?${urlSearchParams}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	saveTasks: ({ plantCd, selectedRows }) => {
		return client
			.post(`${BASE_URL}/task/v1/status/1/plants/${plantCd}/tasks`, selectedRows)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	deleteTasks: ({ plantCd, selectedRows }) => {
		return client
			.post(`${BASE_URL}/task/v1/status/3/plants/${plantCd}/tasks`, selectedRows)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	fetchTaskScript: ({ plantCd, taskId, version }) => {
		return client
			.get(`${BASE_URL}/task/v1/plants/${plantCd}/tasks/${taskId}/versions/${version}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	updateTaskScript: ({ plantCd, taskId, version, task }) => {
		return client
			.post(`${BASE_URL}/task/v1/status/2/plants/${plantCd}/task/${taskId}/version/${version}`, task)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	}
};
